export const accountRedesignContainer = (isLargeScreen: boolean) => ({
	gap: '2rem',
	display: 'flex',
	flexDirection: 'column',

	margin: isLargeScreen ? '2rem 4.5rem 2rem 2.75rem' : '1.25rem 1.25rem 2.5rem 1.25rem',
});

export const accountBreadcrumbContainer = {
	gap: '0.25rem',
	display: 'flex',
	alignItems: 'center',
};

export const accountPersonalInformationRow = {
	gap: '1.5rem',
	display: 'flex',
	alignSelf: 'stretch',
	alignItems: 'flex-start',
};

export const accountSplitContainer = (isLargeScreen: boolean) => ({
	display: 'flex',
	alignSelf: 'stretch',
	alignItems: 'flex-start',
	gap: isLargeScreen ? '1.5rem' : '2rem',
	flexDirection: isLargeScreen ? 'row' : 'column',
});

export const accountInformationContainer = {
	gap: '1.25rem',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',

	width: '100%',
	padding: '1.25rem',
};

export const accountBreak = {
	width: '100%',
	border: '0.5px solid',
	borderColor: 'neutrals.primary',
};

export const paymentSettingsSection = {
	gap: '1rem',
	display: 'flex',
	flexDirection: 'column',
	alignSelf: 'stretch',
};

export const accountInformationLoadingContainer = {
	width: '100%',
	height: '40vh',

	display: 'flex',
	alignItems: 'center',
	flexDirection: 'column',
	justifyContent: 'center',
};
